<template>
    <span class="def-price-old-component">
        <slot />
    </span>
</template>

<script>
export default {
    name: 'DefPriceOld',
    selector: '.def-price-old',
}
</script>

<style lang="scss" scoped>
.def-price-old-component{
    text-decoration-line: line-through;
    color: #757575;
}
</style>